<template>
  <div class="box6">
    <pageTitle title="Apache贡献者<br />985计算机硕士领衔授课" tit />
    <p class="subTitle">
      引进京东、百度、小米、搜狐、360、途牛、平安、德邦、上交所等大厂背景师资，更有多位Apache社区源码贡献者随堂授课
    </p>
    <div class="top-box">
      <div class="block">
        <p>高投入</p>
        <span></span>
        亿元级研发投入<br />技术前沿
      </div>
      <div class="block">
        <p>强质量</p>
        <span></span> 严控教学质量<br />优中选优
      </div>
      <div class="block">
        <p>严考核</p>
        <span></span> 学员满意度打分<br />保障质量
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding-top: 80px;
  width: 100%;
  background: linear-gradient(180deg, #e7f7ff 0%, #cef0ff 100%);
  overflow: hidden;
  .subTitle {
    padding: 0 28px;
    margin: 16px auto 48px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 40px;
    text-align: center;
  }
  .top-box {
    display: flex;
    justify-content: space-evenly;
    margin: 0 auto;
    margin-top: 48px;
    margin-bottom: 48px;
    padding-top: 24px;
    width: 686px;
    height: 168px;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 8px 24px 0px rgba(39, 164, 221, 0.24);
    border-radius: 16px;

    box-sizing: border-box;

    .block {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 36px;
      text-align: center;
      position: relative;
    }

    p {
      margin-bottom: 8px;
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0080ff;
      line-height: 44px;
      transform-style: preserve-3d;
      display: table;
      margin: 0 auto 8px;
    }
    p {
      position: relative;
      z-index: 10;
    }
    span {
      width: 84px;
      left: 50%;
      transform: translateX(-50%);
      height: 12px;
      background: #d0e8ff;
      position: absolute;
      display: block;
      top: 28px;

      z-index: 1;
    }
  }
}
</style>
